/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-modal
  id="modal-size-guide"
  v-model="showModal"
  size="xl"
  centered
  :hide-footer="true"
  @show="onModalShow"
  modal-class="bcm-modal size-guide-modal">
    <template slot="modal-header" slot-scope="{ close }">
      <h3 class="title">{{$t('size-guide')}}</h3>
      <button class="btn btn-icon btn-icon-small btn-icon-no-border btn-rounded" @click="close()">
        <svg class="o-icon stroke-black"><use xlink:href="#close"></use></svg>
      </button>
    </template>
    <b-container fluid>
      <div class="content-html" v-html="htmlCode"></div>
    </b-container>
    <absolute-loader :showLoader="showLoader"></absolute-loader>
  </b-modal>
</template>

<script>
import SizeGuide from 'theme/components/Product/SizeGuide'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'

export default {
  name: 'ModalSizeGuide',
  mixins: [SizeGuide],
  props: {
    product: {
      type: Object,
      required: false,
      default: () => ({})
    },
    value: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      showLoader: true,
      htmlCode: ''
    }
  },
  computed: {
    showModal: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('close', newValue)
      }
    }
  },
  methods: {
    onModalShow () {
      return this.$store.dispatch('product/loadSizeGuide', { productId: this.product.id })
        .then((res) => {
          this.htmlCode = res
        })
        .catch((err) => {
          if (err && err.message) {
            this.htmlCode = `<p class="text-center">${this.$t(err.message)}</p>`
          }
        })
        .finally(() => {
          this.showLoader = false
        })
    }
  },
  components: {
    AbsoluteLoader
  }
}
</script>
